import React from 'react'
import MainLayout from '@/shared/Layouts/MainLayout/index.tsx'
import css from './calendar.module.css'
import Button from '@/shared/Buttons/Button'
import DateButtonGroup from './DateButtonGroup'
import CalendarMonthView from './CalendarMonthView'
import CalendarWeekView from './CalendarWeekView'
import { TSectionType } from './calendar.types'
import useSidePageWithTableCtrl from '@/shared/SidePage/useSidePageWithTableCtrl'
import CalendarSidePage from './SidePages/CalendarSidePage'
import useCalendarCtrl from './hooks/useCalendarCtrl'
import useMaintenancePlans from './hooks/useMaintenancePlans'
import Segmented from '@/shared/Common/Segmented'
import useTitle from '@/shared/hooks/useTitle'

const CalendarPage = () => {
  useTitle('Календарь ТО')
  const ctrl = useCalendarCtrl()
  const { events, isLoaded, resetLoadState } = useMaintenancePlans(ctrl.data.filters)
  const sidePageCtrl = useSidePageWithTableCtrl(events.planned)

  const renderContent = () => {
    switch (ctrl.data.selectedSection) {
      case 'week':
        return (
          <CalendarWeekView
            selectedDay={ctrl.data.selectedDay}
            events={events.planned}
            selectedDates={ctrl.data.filters}
            onClick={sidePageCtrl.handleItemPageOpen}
            isLoaded={isLoaded}
          />
        )
      case 'month':
        return (
          <CalendarMonthView
            onCellClick={ctrl.handlers.handleMonthCellClick}
            events={events.planned}
            selectedDates={ctrl.data.filters}
            isLoaded={isLoaded}
          />
        )
    }
  }

  return (
    <>
      <MainLayout>
        <div className={css.wrapper}>
          <div className={css.main}>
            <div className="flex-lines gap24 height100">
              <div className="flex-lines gap24">
                <h2 style={{ paddingLeft: '4px' }} className="text-heading-3">
                  Календарь ТО
                </h2>
                <div className="flex-space-between">
                  <div className="inline-flex-gap gap16 center">
                    <DateButtonGroup
                      viewingMode={ctrl.data.selectedSection === 'month' ? 'monthYear' : 'range'}
                      onDateChange={(dates) => {
                        resetLoadState()
                        ctrl.handlers.handleDateChange(dates)
                      }}
                      selectedDates={ctrl.data.filters}
                      selectedSection={ctrl.data.selectedSection}
                    />
                    <Button
                      size={'default'}
                      type={'default'}
                      onClick={() => {
                        resetLoadState()
                        ctrl.handlers.handleTodayClick()
                      }}
                      text="Сегодня"
                    />
                  </div>
                  <Segmented
                    style={{ width: 'fit-content ' }}
                    block
                    options={[
                      { value: 'week', label: 'Неделя' },
                      { value: 'month', label: 'Месяц' },
                    ]}
                    value={ctrl.data.selectedSection}
                    onChange={(val) => {
                      resetLoadState()
                      ctrl.handlers.handleSectionChange(val as TSectionType)
                    }}
                  />
                </div>
              </div>
              <div className="height100" style={{ minWidth: '1150px' }}>
                {renderContent()}
              </div>
            </div>
          </div>
        </div>
      </MainLayout>
      <CalendarSidePage
        onCloseAnimationEnd={sidePageCtrl.handleCloseAnimationEnd}
        event={sidePageCtrl.selectedItem}
        open={sidePageCtrl.sidePageOpen}
        onClose={sidePageCtrl.handleClosePage}
      />
    </>
  )
}

export default CalendarPage
